var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page bg-white" },
    [
      _c("vxe-toolbar", {
        attrs: {
          refresh: { query: _vm.refreshList },
          export: "",
          print: "",
          custom: "",
        },
        scopedSlots: _vm._u([
          {
            key: "buttons",
            fn: function () {
              return [
                _vm.hasPermission("extension:flowCopy:del")
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "small",
                          icon: "el-icon-delete",
                          disabled:
                            _vm.$refs.flowCopyTable &&
                            _vm.$refs.flowCopyTable.getCheckboxRecords()
                              .length === 0,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.del()
                          },
                        },
                      },
                      [_vm._v("删除 ")]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticStyle: { height: "calc(100% - 80px)" } },
        [
          _c(
            "vxe-table",
            {
              ref: "flowCopyTable",
              attrs: {
                border: "inner",
                "auto-resize": "",
                resizable: "",
                height: "auto",
                loading: _vm.loading,
                size: "small",
                "show-header-overflow": "",
                "show-overflow": "",
                "highlight-hover-row": "",
                "menu-config": {},
                "print-config": {},
                "import-config": {},
                "export-config": {},
                "sort-config": { remote: true },
                data: _vm.dataList,
                "checkbox-config": {},
              },
              on: { "sort-change": _vm.sortChangeHandle },
            },
            [
              _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
              _c("vxe-column", { attrs: { type: "checkbox", width: "40px" } }),
              _c("vxe-column", {
                attrs: {
                  title: "实例标题",
                  field: "procInsName",
                  sortable: "",
                },
              }),
              _c("vxe-column", {
                attrs: { title: "抄送日期", field: "createDate", sortable: "" },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "抄送发起人",
                  field: "createBy.name",
                  sortable: "",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "操作",
                  width: "150px",
                  type: "html",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.hasPermission("extension:flowCopy:view")
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  icon: "el-icon-view",
                                  size: "mini",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.detail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查阅审批")]
                            )
                          : _vm._e(),
                        _vm.hasPermission("extension:flowCopy:del")
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "mini",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.del(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("vxe-pager", {
            attrs: {
              background: "",
              size: "small",
              "current-page": _vm.tablePage.currentPage,
              "page-size": _vm.tablePage.pageSize,
              total: _vm.tablePage.total,
              "page-sizes": [
                10,
                20,
                100,
                1000,
                { label: "全量数据", value: 1000000 },
              ],
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.currentChangeHandle },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }